import React from 'react';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';

const CustIconButton = ({ icon: Icon, color = 'default', size = 'medium', bgColor, ...props }) => {
    return (
        <IconButton
            color={color}
            size={size}
            sx={{
                backgroundColor: bgColor || 'transparent',
                '&:hover': {
                    backgroundColor: bgColor ? `${bgColor}cc` : undefined, // slightly transparent on hover
                },
            }}
            {...props}
        >
            {Icon && <Icon />}
        </IconButton>
    );
};

CustIconButton.propTypes = {
    icon: PropTypes.elementType.isRequired,
    color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    bgColor: PropTypes.string,
};

export default CustIconButton;
